//Component name should start with capital
import React, { createContext, useEffect, useState } from "react";
import "./App.css";
import Homepage from "./pages/homepage";
import ThemeButton from "./components/theme-button";

//create the context
//provide the context
//consume the context

export const ThemeContext = createContext(null);

const App = () => {
  const [theme, setTheme] = useState(false);
  useEffect(() => {
    const previousTheme = JSON.parse(localStorage.getItem("theme")) || false;

    const { themeStatus } = previousTheme;

    setTheme(themeStatus);

    // setTheme(themeStatus);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <div
        className="App"
        style={
          theme ? { backgroundColor: "#fff" } : { backgroundColor: "#12343b" }
        }
      >
        <ThemeButton />
        <Homepage />
      </div>
    </ThemeContext.Provider>
  );
};

export default App;
